import React from 'react';
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer, Text } from 'recharts';

const COLORS = ['#2c285e', '#006fff', '#ff00cd'];

const MyRing = ({ data }) => {
    const RADIAN = Math.PI / 180;

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
        const radius = 25 + innerRadius + (outerRadius - innerRadius);
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        return (
            <Text x={x} y={y} fill="black" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
            </Text>
        );
    };

    const getRadius = (index, total) => {
        const size = 5;
        const space = (size / 2) + 1;
        const maxOuterRadius = 70;
        const outerRadius = `${maxOuterRadius - (size + space) * index}%`;
        const innerRadius = `${maxOuterRadius - size - (size + space) * index}%`;
        return { outerRadius, innerRadius };
    };

    return (
        <ResponsiveContainer width="100%" height={400}>
            <PieChart>
                {data.map((dataSet, index) => (
                    <Pie
                        key={`pie-${index}`}
                        data={dataSet}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        outerRadius={getRadius(index, data.length).outerRadius}
                        innerRadius={getRadius(index, data.length).innerRadius}
                        fill={COLORS[index % COLORS.length]}
                        dataKey="value"
                        startAngle={90}
                        endAngle={-270}
                        label={index === 0 ? renderCustomizedLabel : null}
                    >
                        {dataSet.map((entry, entryIndex) => (
                            <Cell key={`cell-${entryIndex}`} fill={COLORS[entryIndex % COLORS.length]} />
                        ))}
                        <Cell key={`cell-${index}`} fill={COLORS[index]} />
                    </Pie>
                ))}
                <Text x="50%" y="50%" textAnchor="start" verticalAnchor="start" dominantBaseline="central" className="chart-number">
                    <tspan fontSize="30" fontWeight="bold">1023</tspan>
                    <tspan fontSize="15" x="50%" dy="20">salariés</tspan>
                </Text>
                <Legend align="right" verticalAlign="middle" layout="vertical" />

                <Tooltip />
            </PieChart>
        </ResponsiveContainer>
    );
};

export default MyRing;
